/*
 * @Descripttion: 功能组件注册
 * @Author: zenghua.wang
 * @Date: 2021-04-14 10:32:30
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-10 10:56:29
 */

import Vue from 'vue'
// Vue.component('dragGrid', () => import(/* webpackChunkName: 'dragGrid' */'@/dragComponents/layout/grid.vue'))

// 布局组件
import dragTabs from '@/dragComponents/packages/layout/tabs.vue'
import dragGrid from '@/dragComponents/packages/layout/grid.vue'
import dragColumn from '@/dragComponents/packages/layout/column.vue'
import dragCondition from '@/dragComponents/packages/layout/condition.vue'

// 基础组件
import dragReport from '@/dragComponents/packages/report/report.vue'
import dragScrollboad from '@/dragComponents/packages/scrollboad/scrollboad.vue'
import dragCard from '@/dragComponents/packages/card/card.vue'
import dragDynamicCard from '@/dragComponents/packages/card/dynamicCard.vue'
import dragBorder from '@/dragComponents/packages/border/border.vue'
import dragSwiper from '@/dragComponents/packages/swiper/swiper.vue'
import dragImage from '@/dragComponents/packages/image/image.vue'
import dragProgress from '@/dragComponents/packages/progress/progress.vue'
import dragText from '@/dragComponents/packages/text/text.vue'
import dragDatetime from '@/dragComponents/packages/datetime/datetime.vue'
import dragIframe from '@/dragComponents/packages/iframe/iframe.vue'
import dragButton from '@/dragComponents/packages/button/button.vue'

// 图表组件
import dragEchartBar from '@/dragComponents/packages/echart/bar'
import dragEchartLine from '@/dragComponents/packages/echart/line'
import dragEchartPie from '@/dragComponents/packages/echart/pie'
import dragEchartFunnel from '@/dragComponents/packages/echart/funnel'
import dragEchartGauge from '@/dragComponents/packages/echart/gauge'
import dragEchartRadar from '@/dragComponents/packages/echart/radar'

const components = [
  dragTabs,
  dragGrid,
  dragColumn,
  dragCondition,
  dragCard,
  dragDynamicCard,
  dragBorder,
  dragSwiper,
  dragImage,
  dragProgress,
  dragText,
  dragDatetime,
  dragIframe,
  dragButton,
  dragReport,
  dragScrollboad,
  dragEchartBar,
  dragEchartLine,
  dragEchartPie,
  dragEchartFunnel,
  dragEchartGauge,
  dragEchartRadar
]

export const DragComponents = {
  install(Vue) {
    if (this.installed) return
    this.installed = true
    components.forEach((item) => {
      Vue.component(item.name, item)
    })
  }
}

Vue.use(DragComponents)
